import type { PortfolioWidgetsGroupBy } from "@/hooks/data/usePortfolioWidgets";
import React from "react";

import { formatCurrencyCompact } from "@/utils";
import { SupText } from "@repo/core-ui";
import dappConfig from "@/../config/dapp.config";

interface PortfolioSummaryWidgetProps {
  badge: string;
  groupBy: PortfolioWidgetsGroupBy;
  name: string;
  value: number;
  totalPortfolioValue: number;
}

export default function PortfolioSummaryWidget({ badge, groupBy, name, value, totalPortfolioValue }: PortfolioSummaryWidgetProps) {
  return (
    <div className="flex h-12 w-fit items-center space-x-4 border-0.5 border-neutral-100 bg-neutral-50 p-2">
      <img src={badge} alt={name} className="inline-flex h-6 w-6 overflow-hidden rounded-full object-cover" />
      <div className="flex flex-col items-start justify-center space-y-1">
        <div className="flex items-center justify-between space-x-2">
          <SupText variant="caption" className="text-neutral-700">
            {groupBy === "protocols" ? "Deposits on" : groupBy === "vault_chains" ? "Vaults on" : "Positions on"}
          </SupText>
          <SupText variant="caption" weight="bold" className="text-neutral-800">
            {name}
          </SupText>
        </div>
        <div className="flex items-center justify-between space-x-2 text-neutral-900">
          <SupText variant="subtitle1" family="sans" weight="bold" className="font-medium">
            {formatCurrencyCompact(value, dappConfig.decimalsRoundingLimit, dappConfig.decimalsRoundingLimit)}
          </SupText>
          <SupText variant="subtitle1" family="sans">
            {(totalPortfolioValue > 0 ? (value / totalPortfolioValue) * 100 : 0).toFixed(2)}%
          </SupText>
        </div>
      </div>
    </div>
  );
}
